import React from "react";

export default function Logo({ size = 56, className = "", ...rest }) {
  return (
    <img
      src="/brand/energy-awakens-logo.png"
      alt="Energy Awakens"
      className={`block ${className}`}
      style={{ mixBlendMode: "multiply", height: size, width: size }}
      data-testid="brand-logo"
      {...rest}
    />
  );
}
